var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#8F9299"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1465 8.06977L17.9772 18.3001C17.8136 19.0221 17.3868 19.2018 16.7802 18.8617L13.475 16.426L11.8802 17.96C11.7037 18.1364 11.556 18.2841 11.2159 18.2841L11.4534 14.9178L17.5793 9.38224C17.8457 9.1448 17.5216 9.01321 17.1654 9.25067L9.59217 14.0192L6.33183 12.9988C5.62264 12.7774 5.60983 12.2896 6.47942 11.9495L19.232 7.03649C19.8224 6.81508 20.339 7.16802 20.1465 8.06977Z",
    fill: "#0B111C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTelegram);
export default __webpack_public_path__ + "static/media/Link - Telegram.fbf9de666ee209165aec73cdc3bf0376.svg";
export { ForwardRef as ReactComponent };